import { render, staticRenderFns } from "./bulkUpdteLiability.vue?vue&type=template&id=572d71f2&"
import script from "./bulkUpdteLiability.vue?vue&type=script&lang=js&"
export * from "./bulkUpdteLiability.vue?vue&type=script&lang=js&"
import style0 from "./bulkUpdteLiability.vue?vue&type=style&index=0&id=572d71f2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports